import { useEffect, useRef } from 'react'

const SUPEROFFICE_CHAT_URL = 'https://online.superoffice.com/Cust13410/CS/javascript/chat.js'

const meglerAppChat = () => {
  const meglerAppChatScript = document.createElement('script')
  meglerAppChatScript.async = true
  meglerAppChatScript.src = SUPEROFFICE_CHAT_URL
  meglerAppChatScript.type = 'text/javascript'
  meglerAppChatScript.setAttribute('data-topicId', '2')
  meglerAppChatScript.setAttribute('data-title', 'Chat med oss!')
  meglerAppChatScript.setAttribute('data-theme', 'modern')
  meglerAppChatScript.setAttribute('data-color', '#667C89')
  meglerAppChatScript.setAttribute('data-font', 'arial')
  meglerAppChatScript.setAttribute('data-size', 'normal')
  meglerAppChatScript.setAttribute('data-delay', '1')

  return meglerAppChatScript
}

const Chat = ({user}) => { 
  const hasInitializedRef = useRef(false)

  useEffect(() => {
    const meglerAppChatElement = meglerAppChat()
    meglerAppChatElement.setAttribute('data-customerName', user.name)
    meglerAppChatElement.setAttribute('data-customerEmail', user.email)

    document.head.appendChild(meglerAppChatElement)

    return () => { 
      document.head.removeChild(meglerAppChatElement)
    }
  }, [user])

  useEffect(() => {
    if (!hasInitializedRef.current) {
      setTimeout(() => { 
        if (window.SuperOffice_setupChat) {
          window.SuperOffice_setupChat()
          hasInitializedRef.current = true
        }
      }, 1000)
    }
  }, [user])

  return null
}

export default Chat
